import React from 'react';
import styles from './Component/CSS/ViewMore.module.css';
import { Play, Lock } from 'lucide-react';
import { useAudioPlayer } from '../../components/audio/AudioPlayerContext';
import { useSubscriptionCheck } from '../../hooks/useSubscriptionCheck';

const AudioEpisodes = ({ seriesId, chapters, seriesData }) => {
  // Use the global audio player context
  const { currentAudio, playAudio, isPlaying } = useAudioPlayer();
  const { checkSubscriptionBeforePlay } = useSubscriptionCheck();
  
  // Check if an episode is currently playing
  const isEpisodePlaying = (chapter) => {
    return currentAudio && currentAudio.id === chapter.id;
  };

  // Handle episode click
  const handleEpisodeClick = (chapter) => {
    // Check subscription before playing - only for paid content
    if (!checkSubscriptionBeforePlay(chapter.paid)) {
      return;
    }

    // Format chapter data for the audio player
    const audioData = {
      id: chapter.id,
      title: chapter.audio_title || `Episode ${chapter.chapter_number}`,
      author: seriesData?.creator?.name || "Unknown Author",
      song_url: chapter.audio_url,
      image: chapter.audio_computer_image || chapter.audio_mobile_image || seriesData?.coverImageUrl,
      duration: chapter.audio_duration,
      audioId: chapter.audio_id,
      slug: chapter.slug || seriesData?.slug
    };
    
    // Play the audio using the global context
    playAudio(audioData);
  };

  // Format duration from seconds to MM:SS
  const formatDuration = (seconds) => {
    if (!seconds) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes} mins ${remainingSeconds} secs`;
  };



  if (!chapters || chapters.length === 0) {
    return <div className={styles.noEpisodes}>No episodes available</div>;
  }

  return (
    <div className={styles.episodesContainer}>
    <h2 className={styles.episodeTitle}>Episodes</h2>
      {chapters.map((chapter, index) => (
        <div 
          key={chapter.id} 
          className={`${styles.episodeCard} ${isEpisodePlaying(chapter) ? styles.playing : ''}`}
          onClick={() => handleEpisodeClick(chapter)}
        >
          <div className={styles.episodeDetails}>
            <div className={styles.episodeImage}>
              <img
                src={chapter.audio_computer_image || chapter.audio_mobile_image || '/default-episode.jpg'}
                alt={chapter.audio_title || `Episode ${chapter.chapter_number}`}
              />
              {isEpisodePlaying(chapter) && isPlaying && (
                <div className={styles.playingIndicator}>
                  <div className={styles.bar}></div>
                  <div className={styles.bar}></div>
                  <div className={styles.bar}></div>
                </div>
              )}
              {!isEpisodePlaying(chapter) && (
                <div className={styles.playIcon}>
                  {chapter.paid ? (
                    <Lock size={20} color="white" />
                  ) : (
                    <Play size={20} color="white" />
                  )}
                </div>
              )}
            </div>
            
            <div className={styles.episodeInfo}>
              <div className={styles.episodeTitle}>
                {index + 1}. {chapter.audio_title || `Episode ${chapter.chapter_number}`}
                <span className={styles.arrow}>›</span>
              </div>
              <div className={styles.episodeDuration}>
                {formatDuration(chapter.audio_duration)}
              </div>
              {chapter.paid && (
                <div className={styles.paidBadge}>Premium</div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AudioEpisodes;